module.exports = __webpack_public_path__ + "img/waiting.94790705.svg";